"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _immutable = require("immutable");

var _fluxActions = require("flux-actions");

var _WorkspaceAudit = _interopRequireWildcard(require("../records/WorkspaceAudit"));

var _PayloadActions = require("../actions/PayloadActions");

var _WorkspaceActions = require("../actions/WorkspaceActions");

var _handleActions;

var initialState = (0, _immutable.Map)();

var _default = (0, _fluxActions.handleActions)((_handleActions = {}, (0, _defineProperty2.default)(_handleActions, _PayloadActions.FetchPayloadActionTypes.SUCCESS, function (state, action) {
  return state.withMutations(function (map) {
    action.payload.data.mostRecentAuditsByWorkspace.reduce(function (acc, ws) {
      return acc.set(ws.workspaceId, (0, _WorkspaceAudit.fromJSON)(ws));
    }, map);
  });
}), (0, _defineProperty2.default)(_handleActions, (0, _fluxActions.combineActions)(_WorkspaceActions.CreateWorkspaceActionTypes.SUCCESS, _WorkspaceActions.EditWorkspaceActionTypes.SUCCESS), function (state, action) {
  var _action$payload$data = action.payload.data,
      workspace = _action$payload$data.workspace,
      authedUser = _action$payload$data.authedUser;
  var newAudit = new _WorkspaceAudit.default({
    actionAt: Date.now(),
    user: authedUser
  });
  return state.set(workspace.id, newAudit);
}), _handleActions), initialState);

exports.default = _default;
module.exports = exports.default;